module.exports = __webpack_public_path__ + "media/assets/icons/pay-it-forward-bg-09b05c0ddd128b0ce634ae715a137a9d.png";